import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { CircleX, CircleCheck, CircleHelp } from "lucide-react";
import { cn } from "../utils";

type T_props = {
  title?: string;
  message: React.ReactNode;
  id: string;
  visible?: boolean;
} & VariantProps<typeof iconVariants>;

const iconVariants = cva("", {
  variants: {
    type: {
      success: "text-teal-500",
      error: "text-red-500",
    },
  },
  defaultVariants: {
    type: "success",
  },
});

export const Notification = ({
  id,
  message,
  title,
  type = "success",
  visible,
}: T_props) => {
  const iconMap = {
    success: CircleCheck,
    error: CircleX,
  };

  const Icon = type ? iconMap[type] : CircleHelp;

  return (
    <div
      className={cn(
        visible ? "animate-enter" : "animate-leave",
        "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-gray-400 ring-opacity-5"
      )}
    >
      <div className="flex-1 p-4 w-0">
        <div className="flex items-center">
          <div className="flex-shrink-0 pt-0.5">
            <Icon className={iconVariants({ type })} />
          </div>
          <div className="flex-1 ml-3">
            {title && <p className="text-gray-900 text-sm">{title}</p>}
            <p className="mt-1 font-light text-gray-600 text-sm">{message}</p>
          </div>
        </div>
      </div>
      {/* <div className="flex border-gray-200 border-l">
        <button
          onClick={() => toastPrimitive.dismiss(id)}
          className="flex justify-center items-center p-4 border border-transparent rounded-none rounded-r-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 w-full font-medium text-indigo-600 hover:text-indigo-500 text-sm"
        >
          Cerrar
        </button>
      </div> */}
    </div>
  );
};
